var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10313 3.51564C4.42759 3.51564 4.69063 3.2526 4.69063 2.92814C4.69063 2.60367 4.42759 2.34064 4.10313 2.34064C3.77866 2.34064 3.51562 2.60367 3.51562 2.92814C3.51562 3.2526 3.77866 3.51564 4.10313 3.51564Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 1.17188V10.5469H1.17188V11.7188H11.7188V1.17188H10.5469Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 0H0V9.375H9.375V0ZM8.20312 5.85938L5.85938 3.51562L4.39375 4.98125L3.51562 4.10313L1.17188 6.44687V1.17188H8.20312V5.85938Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/GalleryIcon.92a326e0f23a56a9835401e2a6923ae1.svg";
export { ForwardRef as ReactComponent };